<template>
    <section id="contact-popup">
        <div id="container-contacts-form" class="container d-flex">
            <div class="text-align-start formHeader">
                <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
                <span style="vertical-align: middle; font-weight: 600">Contatos</span>
            </div>
            <div id="div-title">
                <i class="fa fa-address-book fa-2x" aria-hidden="true" style="color: rgb(28,134,154)"></i>
                <h2 id="container-title">Cadastro de Contatos</h2>
            </div>
            <form action="" id="contacts-form">
                <div class="input-group">
                    <label for="contactName">Nome completo do Aluno</label>
                    <input
                        class="form-control"
                        name="contactName"
                        type="text"
                        v-model="contact.name"
                        placeholder="Insira o nome completo do aluno"
                        required>
                </div>
                <div class="input-group">
                    <label for="contactPhone">Telefone</label>
                    <vue-tel-input 
                        id="phone-input" 
                        defaultCountry="BR"
                        mode="international" 
                        v-model="contact.phone"
                        :inputOptions="options">
                    </vue-tel-input>
                </div>
                <div class="input-group">
                    <label for="contactEmpresa">Curso</label>
                    <input
                        class="form-control"
                        name="contactEmpresa"
                        type="text"
                        v-model="contact.company_name"
                        placeholder="Insira o nome do Curso"
                        required>
                </div>

                <div class="input-group">
                    <label for="contactEmpresa">Turma</label>
                    <input
                        class="form-control"
                        name="contactEmpresa"
                        type="text"
                        v-model="contact.wallet_group"
                        placeholder="Insira o nome da Turma"
                        required>
                </div>

                <!-- Seletor CPF/CNPJ desativado: o campo virou Matricula (RA)
                <div class="input-group mt-2">
                    <select class="form-control mr-3 ml-3" name="id-cpf" id="id-cpf" v-model="idCpf" style="flex: 1">
                        <option value="cpf" selected>CPF</option>
                        <option value="cnpj">CNPJ</option>
                    </select>
                    <input class="form-control"
                        name="contactKey"
                        type="text"
                        v-model="contact.unique_key"
                        :placeholder="maskPlaceholder"
                        @input="applyMask"
                        style="flex: 4"
                    >
                </div>
                -->

                <div class="input-group mt-2">
                    <label for="contactKey">Matrícula (RA)</label>
                    <input class="form-control"
                        name="contactKey"
                        type="text"
                        v-model="contact.unique_key"
                        placeholder="Insira a matrícula (RA)"
                    >
                </div>

                <div class="input-group mt-2">
                    <label for="contactConsultor">Consultor</label>
                    <select class="form-control" name="contactConsultor" id="contactConsultor" v-model="contact.consultor" style="flex: 1">                
                        <option v-for="consultor in arrayConsultor" :value="consultor.extension_line">{{ consultor.name }}</option>
                    </select>
                </div>

                <div v-if="saving">
                    <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
                </div>                
                <div v-else >
                    <button    
                        type="submit"
                        class="btn btn-success"
                        id="btn-save"
                        form="chamadoForm"
                        @click.prevent="saveContact()"
                    ><i class="fas fa-check"></i>
                        Salvar
                    </button>
                    <button 
                        type="submit"
                        class="btn btn-danger"
                        id="btn-cancel"
                        form="chamadoForm"
                        @click.prevent="resetContact()"
                    ><i class="fas fa-window-close fa-fw"></i>
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    </section>
</template>
    
<script>

import {mapActions, mapGetters, mapMutations} from 'vuex';
import swal from 'sweetalert';
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default {
    name: "ContatosRapido",
    props: ['addWppContact'],
    data(){
        return {
            contact: {
                name: "",
                phone: "",
                unique_key: "",
                company_name: "",
                consultor: "",
                wallet_group: ""
            },
            arrayConsultor: [],
            saving: false,
            idCpf: "cpf",
            options: {
                placeholder: 'Insira o telefone',
                required: true
            }
        }
    },
    created() {
		this.loadFila();
	},
    components: {
        ...mapGetters(['getContacts']),
    },
    methods:{
        ...mapActions(["transferOptions"]),
        loadFila(){
            axios.get('/queue-consultor').then(({ data }) => {
                let allOperators = [];

                // Juntar todos os operadores em uma única lista
                Object.keys(data).forEach(key => {
                    allOperators = allOperators.concat(data[key].operadores);
                });

                // Remover duplicatas baseadas em extension_line
                const uniqueOperators = allOperators.filter((operator, index, self) =>
                    index === self.findIndex((o) => (
                        o.extension_line === operator.extension_line
                    ))
                );

                // Atribuir o array final ao arrayConsultor
                this.arrayConsultor = uniqueOperators;
            });
        },
        // Mascara de CPF/CNPJ desativada: a Matricula (RA) pode ter letras
        // applyMask() {
        //     if (this.idCpf === 'cpf') {
        //         let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 11);
        //         this.contact.unique_key = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        //     } else if (this.idCpf === 'cnpj') {
        //         let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 14);
        //         this.contact.unique_key = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        //     }
        // },
        checkForm() {
            if (this.contact.name == undefined || this.contact.name == null || this.contact.name == '') {
                Swal.fire({
                    html: 'O campo "Nome Contato" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
            }

            if (this.contact.phone == undefined || this.contact.phone == null || this.contact.phone == '') {
                Swal.fire({
                    html: 'O campo "Telefone" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;  
            } else {
                return true;
            }
        },
        saveContact() {
            if(this.checkForm()) {
                this.saving = true
                axios.post("dialer/saveContact", this.contact).then(() => {
                    Swal.fire({
                        type: "success",
                        title: "Feito!",
                        text: "Contato salvo com sucesso!"
                    }).then(() =>{
                  	  this.saving = false;
                  	  this.contact.name = "";
                  	  this.contact.phone = "";
                      this.contact.unique_key =  "";
                      this.idCpf = "cpf";
                      this.contact.company_name = "";
                      this.contact.consultor = "";
                      this.contact.wallet_group = "";
                      this.$emit('closeContacts');
	                });  
                });
            }
        },

        resetContact() {
            Swal.fire({
                title: 'Deseja descartar as informações?',
                text: 'Você perderá as alterações não salvas!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: 'rgb(28,134,154)',
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Voltar ao formulário'
            }).then((result) => {
                if(result.value){
                  	  this.contact.name = "";
                  	  this.contact.phone = "";
                      this.contact.unique_key =  "";
                      this.idCpf = "cpf";
                      this.contact.company_name = "";
                      this.contact.consultor = "";
                      this.contact.wallet_group = "";
                      this.$emit('closeContacts');
                }
            })
        },
        async setClientData(client) {		
			if( (client.phone || client.name) && client.type == 'chat'){		
                
                let phoneArr = client.phone.split('@');
				let phoneEdited = phoneArr[0].substr(2);

				this.contact = {
					'name': client.name,
					'phone': phoneEdited,
				}
			}
		}
    },
    computed:{
		...mapGetters([
			'getContacts',
		]),
        ...mapActions(['setMessage']),
        // Placeholder de CPF/CNPJ desativado: o campo virou Matricula (RA)
        // maskPlaceholder() {
        //     if (this.idCpf === 'cpf') {
        //         return 'XXX.XXX.XXX-XX';
        //     } else if (this.idCpf === 'cnpj') {
        //         return 'XX.XXX.XXX/XXXX-XX';
        //     }
        // }
    },

    watch: {
        // Sem seletor de CPF/CNPJ nao ha mais o que observar
        // idCpf() {
        //     this.contact.unique_key = "";
        // },
        addWppContact(data) {
            if(data){
                const phone = data.phone
                const phoneEdited = '+' + phone ;

                if(data.cpfCnpj && data.cpfCnpj != '') {
                    if(data.cpfCnpj.length == 14){
                        this.idCpf = 'cnpj';
                    } else {
                        this.idCpf = 'cpf';
                    }
                }

                setTimeout(() => {
                    this.contact = {
                        'name': data.name,
                        'phone': phoneEdited,
                        'unique_key': data.cpfCnpj ? data.cpfCnpj : '',
                        'consultor': ''
                    }
                }, 500)
            }
        },
    }
}
</script>

<style scoped>

    #contact-popup{
        display: flex;
        justify-content: center;
        position: absolute;
        top: 55px;
        right: 25vw;
    }
    .formHeader {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;
        display: flex;
        border-radius: 20px 20px 0px 0px
    }

    .input-group{
        width: 90%;
        align-self: center;
        line-height: 2.55;
    }

    #container-contacts-form{
        width: 35vw;
        border: solid 2px lightgray;
        border-radius: 25px;
        text-align: center;
        flex-direction: column;
        margin: 10px;
        padding: 0;
        background-color: white;
    }

    #saving {
        color: rgb(28,134,154);
        font-size: 16px;
        text-align: center
    }

    #div-title {
        display: flex;
        flex-direction: column;
        margin: 20px;
    }

    #contacts-form{
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    #buttonGroup {
        display: flex;
        justify-content: center;
    }
    
    #phone-input{
        height: 2.5em;
        align-self: center;
        flex: 3;
    }

    #btn-save {
        border: solid 2px #008000;
        border-radius: 20px;
        background-color: #008000;
        color: white;
        transition: 0.5s
    }
    
    #btn-save:hover {
        color: #008000;
        background-color: white;

    }

    #btn-cancel {
        border: solid 2px #b30000;
        border-radius: 20px;
        background-color: #b30000;
        color: white;
        transition: 0.5s
    }
    
    #btn-cancel:hover {
        color: #b30000;
        background-color: white;

    }

    section {
        display: flex;
        justify-content: center;
    }

    h2 {
        color: rgb(28,134,154)
    }

    label{
        margin: 10px;
        font-size: 16px;
        font-weight: 500;
    }

    select {
        align-self: center;
    }

    input {
        width: 40px;
        align-self: center;
    }

    button {
        width: 120px;
        margin: 20px;
        border-radius: 10px !important
    }
</style>
